import { render, staticRenderFns } from "./SettingsTournamentType.vue?vue&type=template&id=2b40ddee&"
import script from "./SettingsTournamentType.vue?vue&type=script&lang=js&"
export * from "./SettingsTournamentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports